/** Decodes the server's public notification key into the bytes the browser wants. */
export function urlBase64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob(padded.replace(/-/g, '+').replace(/_/g, '/'));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export interface DeviceInfo {
  isIos: boolean;
  /** Opened from the Home Screen icon (not a Safari tab). */
  standalone: boolean;
  hasServiceWorker: boolean;
  hasPush: boolean;
  permission: NotificationPermission | 'unsupported';
}

export function readDevice(): DeviceInfo {
  const ua = navigator.userAgent;
  const isIos =
    /iPhone|iPad|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return {
    isIos,
    standalone,
    hasServiceWorker: 'serviceWorker' in navigator,
    hasPush: 'PushManager' in window,
    permission: 'Notification' in window ? Notification.permission : 'unsupported',
  };
}

export type PushState =
  'needs-install' | 'unsupported' | 'blocked' | 'enabled' | 'permission-needed';

/** What the notification card should offer, given what this device can do. */
export function pushStateFor(device: DeviceInfo, hasSubscription: boolean): PushState {
  // On iPhone, notifications only exist for an app opened from the Home Screen.
  if (device.isIos && !device.standalone) return 'needs-install';
  if (!device.hasServiceWorker || !device.hasPush || device.permission === 'unsupported') {
    return 'unsupported';
  }
  if (device.permission === 'denied') return 'blocked';
  if (device.permission === 'granted' && hasSubscription) return 'enabled';
  return 'permission-needed';
}
